module.exports = __webpack_public_path__ + "img/circle_red.81771eb6.png";